import { useState, useEffect } from "react";
import classes from "../../CriteriaSubmission/criteriaSubmission.module.css";
import FileUploader from "../../UI/UploadContent/fileUploader";
import { useSelector, useDispatch } from "react-redux";
import { setReadingPassage } from "../../../slices/form";

const UploadContent = ({ textLabel, textPlaceholder, nameInStore, selectStoreData, setStoreData, textBoxHeight="250px", useReadingPassage = false })  => {
  const storeData = useSelector(selectStoreData);
  const dispatch = useDispatch();
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(null);
  const [text, setText] = useState('');

  // Effect to synchronize the internal text state with the store's state on component mount and whenever the store's state changes
  useEffect(() => {
    const newValue = useReadingPassage ? storeData?.readingPassage || "" : storeData?.[nameInStore] || "";

    if (text !== newValue) {
      setText(newValue);
      
      // Update word count to match the new text
      const inputWords = newValue?.split(/\s+/).filter(function (word) {
        return word.length > 0;
      });
      setWordCount(inputWords.length);
    }
  }, [storeData, nameInStore, useReadingPassage]);

  const handleTextChange = (event) => {
    let inputValue = event.target.value;
    const inputWords = inputValue?.split(/\s+/).filter(function (word) {
      return word.length > 0;
    });

    setWordCount(inputWords.length);
    setCharCount(null);

    if (inputWords.length > 10000) {
      inputValue = inputWords.slice(0, 10000).join(" ");
      setWordCount(inputWords.slice(0, 10000).length);
      setCharCount(inputValue.length);
    }

    setText(inputValue);
    
    // If using readingPassage mode, update both readingPassage (for display) and formData.text (for server)
    // Otherwise, update the specified field in formData
    if (useReadingPassage) {
      dispatch(setReadingPassage(inputValue));
      dispatch(setStoreData({ text: inputValue }));  // Also update formData.text for server submission
    } else {
      dispatch(setStoreData({ [nameInStore]: inputValue }));  // Only send the changed field
    }
  };


  return (
    <>
          <div className={classes["input-container"]} data-testid="upload-content">

  <label className={classes.formLabel} htmlFor={nameInStore}>{textLabel} </label>
        <div className={classes["textAndFileContainer"]}>
          <div style={{height:textBoxHeight}} className={classes.textAreaContainer}>
            <textarea
              style={{
                 resize: "none",
              
              }}
              name={nameInStore}
              id={nameInStore}
              className={`${classes.textAreaNoBorder} ${
                wordCount === 10000 ? classes.textAreaMax : ""
              }`}
              onChange={handleTextChange}
              maxLength={charCount}
              placeholder={textPlaceholder}
              value={text}
      
              aria-label={textLabel}
              aria-describedby={`upload-content-word-count-${nameInStore}`}
            />
            <div className={classes.wordCount} id={`upload-content-word-count-${nameInStore}`}>({wordCount}/10000)</div>
          </div>
          <div style={{ margin: "0px 20px 0px 20px" }}>
            <FileUploader 
              nameInStore={useReadingPassage ? "text_files" : nameInStore+"_files"} 
              selectStoreData={selectStoreData} 
              setStoreData={setStoreData} 
            />
          </div>       
         
        </div>
      </div>
    </>
  );
};

export default UploadContent;
